import { useLocation } from "react-router-dom";

// Shown on every owner page when signed in with the read-only investor account.
// The server refuses every write for guest tokens; this banner explains why buttons don't act.
export const GuestBanner = () => {
  const { pathname } = useLocation();
  if (!pathname.startsWith("/owner")) return null;
  if (localStorage.getItem("er-owner-role") !== "guest") return null;
  return (
    <div
      data-testid="guest-banner"
      className="border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 text-center text-[10px] uppercase tracking-[0.25em] text-amber-300"
    >
      Investor demo — read only · nothing here can be changed
    </div>
  );
};
